// Context that lets HeadsUpDisplay override the active brand theme at runtime.
// Only relevant in non-prod environments — HeadsUpDisplay never mounts in prod.
import { createContext, useContext, useState } from 'react';
import type { LWApiPublicAccountSupportSignupParamsRaw } from '@liquidweb-dev/club-sauce/public/account/index.raw';

type Brand = LWApiPublicAccountSupportSignupParamsRaw['brand'];

interface DevThemeContextValue {
	brand: Brand | null;
	setBrand: (brand: Brand | null) => void;
}

export const DevThemeContext = createContext<DevThemeContextValue>({
	brand: null,
	setBrand: () => {},
});

export const useDevTheme = () => useContext(DevThemeContext);

interface DevThemeProviderProps {
	children: React.ReactNode;
}

export const DevThemeProvider = ({ children }: DevThemeProviderProps) => {
	const [brand, setBrand] = useState<Brand | null>(null);

	return (
		<DevThemeContext.Provider value={{ brand, setBrand }}>
			{children}
		</DevThemeContext.Provider>
	);
};
